import { ArrowUpRight } from "lucide-react";
import drawing from '../assets/pexels-photo-1109541.jpeg'
export default function About() {
  const stats = [
    { value: "15"  ,icon:'+', label: "Лет опыта" },
    { value: "120", icon:'+', label: "Довольных клиентов" },
    { value: "98", icon:'%', label: "Успешных проектов" },
  ];

  return (
    <section className="bg-[#fafaf9] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-stretch">
          
          {/* Image Container */}
          <div className="relative h-full lg:min-h-[620px]">
            <div className="h-full min-h-[420px] lg:min-h-[620px] rounded-sm overflow-hidden shadow-2xl">
              <img
                src={drawing}
                alt="Строительная площадка"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-primaryBlue text-white p-6 rounded-[2px] shadow-xl">
              <div className="text-4xl font-bold">100%</div>
              <div className="text-sm">Удовлетворённость клиентов</div>
            </div>
          </div>

          {/* Text Container */}
          <div className="h-full lg:min-h-[620px] flex flex-col justify-center max-w-3xl">
            <div className="flex items-center gap-4 mb-10">
              <span className="w-10 h-px bg-[#147f8f]" />
              <span className="text-sm font-bold tracking-[0.35em] uppercase text-[#147f8f]">
                О БАРТ ГРУП
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-5xl leading-[1.08] tracking-[-0.04em] text-slate-950 mb-10">
              <span className="font-semibold block">
                Мы строим объекты,
              </span>
              <span className="font-light text-slate-500 block">
                которые служат десятилетиями.
              </span>
            </h2>

            <div className="space-y-7 text-lg leading-[1.8] text-slate-600 max-w-lg">
              <p>
                БАРТ ГРУП — строительная компания с более чем 15-летним опытом
                в проектировании, строительстве и ремонте объектов различной
                сложности.
              </p>

              <p>
                Мы объединяем профессиональную команду строителей,
                проектировщиков и инженеров, чтобы каждый этап — от идеи до
                сдачи объекта — был выполнен точно, качественно и в срок.
              </p>
            </div>

            <div className="my-7 h-px w-full bg-slate-200" />

            <div className="grid grid-cols-3 gap-8">
              {stats.map((stat, index) => (
                <div key={index}>
                  <div className="text-2xl md:text-3xl leading-none font-bold tracking-[-0.04em] text-slate-950">
                    {stat.value} <span className='text-sm md:text-lg text-[#147f8f]'>{stat.icon}</span>
                  </div>
                  <div className="mt-3 text-sm md:text-base text-slate-500">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="my-7 h-px w-full bg-slate-200" />

            <a
              href="/about"
              className="inline-flex w-fit items-center gap-4 border border-slate-900 px-10 py-5 text-lg font-semibold text-slate-950 hover:bg-[#147f8f] hover:text-white transition-all duration-300"
            >
              Подробнее о нас
              <ArrowUpRight className="w-5 h-5" />
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}